import { Avatar, Box, Container, Typography } from '@mui/material'
import { Dispatch } from '@reduxjs/toolkit'
import { useSnackbar } from 'notistack'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import * as Yup from 'yup'

import * as routes from '../../config/constants'
import { IsItem } from '../../interfaces/IsItem'
import Button from '../../shared/Button'
import { Form, FormField, SubmitButton } from '../../shared/forms'
import FormTextField from '../../shared/forms/FormTextField'
import LoadingButtonForm from '../../shared/forms/LoadingButtonForm'
import {
  getError,
  getIsUserInfo,
  getMessage,
  getUserCity,
  getUserInfo,
  getUserName,
  resetPassword,
  setError,
  setMessage,
  updateProfile,
} from '../../store/auth'

interface FormValues {
  id: string
  properties: {
    name: string
    city: string
  }
}
const City: IsItem[] = [
  { id: '1', label: 'آذربایجان شرقی', value: 'آذربایجان شرقی' },
  { id: '2', label: 'آذربایجان غربی', value: 'آذربایجان غربی' },
  { id: '3', label: 'اردبیل', value: 'اردبیل' },
  { id: '4', label: 'اصفهان', value: 'اصفهان' },
  { id: '5', label: 'البرز', value: 'البرز' },
  { id: '6', label: 'ایلام', value: 'ایلام' },
  { id: '7', label: 'بوشهر', value: 'بوشهر' },
  { id: '8', label: 'تهران', value: 'تهران' },
  { id: '9', label: 'چهارمحال و بختیاری', value: 'چهارمحال و بختیاری' },
  { id: '10', label: 'خراسان جنوبی', value: 'خراسان جنوبی' },
  { id: '11', label: 'خراسان رضوی', value: 'خراسان رضوی' },
  { id: '12', label: 'خراسان شمالی', value: 'خراسان شمالی' },
  { id: '13', label: 'خوزستان', value: 'خوزستان' },
  { id: '14', label: 'زنجان', value: 'زنجان' },
  { id: '15', label: 'سمنان', value: 'سمنان' },
  { id: '16', label: 'سیستان و بلوچستان', value: 'سیستان و بلوچستان' },
  { id: '17', label: 'فارس', value: 'فارس' },
  { id: '18', label: 'قزوین', value: 'قزوین' },
  { id: '19', label: 'قم', value: 'قم' },
  { id: '20', label: 'کردستان', value: 'کردستان' },
  { id: '21', label: 'کرمان', value: 'کرمان' },
  { id: '22', label: 'کرمانشاه', value: 'کرمانشاه' },
  { id: '23', label: 'کهگیلویه و بویراحمد', value: 'کهگیلویه و بویراحمد' },
  { id: '24', label: 'گلستان', value: 'گلستان' },
  { id: '25', label: 'گیلان', value: 'گیلان' },
  { id: '26', label: 'لرستان', value: 'لرستان' },
  { id: '27', label: 'مازندران', value: 'مازندران' },
  { id: '28', label: 'مرکزی', value: 'مرکزی' },
  { id: '29', label: 'هرمزگان', value: 'هرمزگان' },
  { id: '30', label: 'همدان', value: 'همدان' },
  { id: '31', label: 'یزد', value: 'یزد' },
]

const validationSchema = Yup.object().shape({
  // city: Yup.string().required().label('city'),
})

const ProfileScreen: React.FC = () => {
  const userInfo = useSelector(getIsUserInfo)
  const userCity = useSelector(getUserCity)
  const userName = useSelector(getUserName)

  const initialValues: FormValues = {
    id: userInfo.sub,
    properties: { city: userCity, name: userName },
  }

  const { t } = useTranslation()
  const id = userInfo.sub
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const error = useSelector(getError)
  const message = useSelector(getMessage)
  const dispatch = useDispatch<Dispatch<any>>()
  const handleClick = () => {
    dispatch(resetPassword({ phoneNumber: userInfo.phone_number }))
    navigate(routes.CHANGE_PASSWORD_PROFILE, { state: { phoneNumber: userInfo.phone_number } })
  }
  const handleSubmit = (values: any) => {
    dispatch(updateProfile(values))
  }
  useEffect(() => {
    if (error === undefined) return
    enqueueSnackbar(error, { variant: 'error' })

    dispatch(setError(undefined))
  }, [error])
  useEffect(() => {
    if (message === undefined) return
    enqueueSnackbar(message, { variant: 'success' })
    dispatch(setMessage(undefined))
    // navigate(`/${routes.CARS}`)
  }, [message])
  useEffect(() => {
    dispatch(getUserInfo(id))
  }, [])
  return (
    <Container fixed maxWidth='xs'>
      <Box display='flex' justifyContent='center' sx={{ mt: 2 }}>
        <img alt='Logo' src='images/TinyLogo.png' />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          mt: 23,
          direction: 'ltr',
          // backgroundImage: `url(${'images/background.jpg'})`,
        }}
      >
        <Box
          sx={{ mb: 2, ml: 1, display: 'grid', justifyContent: 'center', flexDirection: 'column' }}
        >
          {/* <Avatar alt='Remy Sharp' src='/static/images/avatar/1.jpg' /> */}
          {/* <Typography>sajjad</Typography> */}
        </Box>
        <Box
          sx={{
            mb: 2,
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'row',
            background: 'white',
            p: 2,
            borderRadius: 1,
            border: 'solid',
            borderColor: 'red',
          }}
        >
          <Typography>{t('screens.profile.phoneNumber_text_placeholder')}</Typography>
          <Typography>{userInfo.phone_number}</Typography>
        </Box>

        <Form
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >
          <FormField
            name='properties.name'
            placeholder={t('screens.profile.fullName_input_placeholder')}
          />
          <FormTextField
            items={City}
            label={t('screens.profile.city_input_placeholder')}
            name='properties.city'
            select
          />
          <SubmitButton title={t('screens.profile.submit_button_text')} />
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
            <Button onClick={handleClick} variant='text'>
              {t('screens.profile.changePassword_button_text')}
            </Button>
          </Box>
        </Form>
      </Box>
    </Container>
  )
}

export default ProfileScreen
